import axios from "axios"
import { URL_BASE } from '../../../config/config'

const RESOURCE = 'accounts'


export default {
    state: {
        items: {
            data: []
        }
    },

    mutations: {
        LOAD_ACCOUNTS (state, data) {
            state.items = data
        },
    },

    actions: {
        loadAccounts(context, params) {
            context.commit('PRELOADER', true)
            axios.get(`${URL_BASE}${RESOURCE}`, {params})
                .then( response =>
                        {
                            context.commit('LOAD_ACCOUNTS', response.data)
                        }
                )
                //.catch( errors => console.log(errors))
                .catch((error) => {
                    if(error.response && error.response.status === 401) {
                        window.location.href = "login";
                    }

                })
                .finally(() => context.commit('PRELOADER', false))
        },
    },

    getters: {

    }

}